import { CredimaxPaymentDetailsModel } from "../Booking/CredimaxPaymentDetailsModel";

export class RecentAppointmentsDataModel {
	DoctorName: string;

	DepartmentName: string;
    DepartmentId: string;
	ScheduleTime: string;

	AppointmentDate: string;

    Status: string;

    RequestNo: string;
   
    PaymentStatus : string;

	ConsultationFees : string;

	AppointmentNo : string;

    DoctorCode: string;

    buttonActivity: string;
    PaymentTypeMode: string;

    credimaxPaymentDetails: CredimaxPaymentDetailsModel[] = [];
    IsTimeElapsed: string;

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/VisitHistory/RecentAppointmentsDataModel.ts